import React from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { DateTime } from "components/common/Date";
import OverviewTab from "./OverviewTab";
import { useSupplierOverview } from "./SupplierOverviewContext";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const Section = () => {
  const { supplier } = useSupplierOverview();
  const { can } = useAccess();
  const canUpdate = can(Permissions.SUPPLIER.UPDATE);

  if (!supplier) {
    return (
      <Row>
        <Col lg={12}>
          <p className="text-muted mb-0">This supplier could not be loaded.</p>
        </Col>
      </Row>
    );
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card className="mt-n4 mx-n4">
            <div className="bg-light-subtle">
              <CardBody className="pb-0 px-4">
                <Row className="mb-3">
                  <div className="col-md">
                    <div>
                      <h4 className="fw-bold">{supplier.name}</h4>
                      {supplier.code && (
                        <p className="text-muted mb-1">
                          <span className="fw-medium">{supplier.code}</span>
                        </p>
                      )}
                      <div className="hstack gap-3 flex-wrap">
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted">Active:</span>
                          {supplier.isActive === false ? (
                            <span className="badge bg-danger-subtle text-danger">Inactive</span>
                          ) : (
                            <span className="badge bg-success-subtle text-success">Active</span>
                          )}
                        </div>
                        {supplier.created_at && (
                          <>
                            <div className="vr" />
                            <div>
                              Created:{" "}
                              <span className="fw-medium">
                                <DateTime date={supplier.created_at} />
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  {canUpdate ? (
                    <div className="col-md-auto">
                      <div className="hstack gap-2 flex-nowrap">
                        <Link
                          to={`/inventory-management/suppliers/edit/${supplier.id}`}
                          className="btn btn-primary btn-sm"
                        >
                          <i className="ri-pencil-line align-bottom me-1" />
                          Edit
                        </Link>
                      </div>
                    </div>
                  ) : null}
                </Row>

                <Nav className="nav-tabs-custom border-bottom-0" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames("active", "text-body fw-semibold")}
                      href="#"
                      onClick={(e) => e.preventDefault()}
                    >
                      Overview
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardBody>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <TabContent activeTab="1" className="text-muted">
            <TabPane tabId="1">
              <OverviewTab />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Section;
